<template>
  <q-card
    v-ripple
    class="article-card cursor-pointer relative-position"
    @click="dialogOpen = true"
  >
    <q-img
      :src="thumbnailImg"
      height="150px"
      class="dimmed darker"
    />
    <div class="absolute-center text-center text-white full-width q-px-sm">
      <q-item-label class="text-bold">
        {{ article.title }}
      </q-item-label>
      <q-item-label
        v-if="article.description"
        class="text-caption article-excerpt"
      >
        {{ article.description }}
      </q-item-label>
      <q-icon
        name="mdi-youtube"
        size="4em"
      />
    </div>

    <content-dialog
      v-model="dialogOpen"
      title="Video"
      always-on-top
      width="80vh"
      fullscreen-mobile
      skip-help-checks
    >
      <sticky-header static>
        {{ article.title }}
      </sticky-header>
      <q-item-label
        v-if="article.description"
        class="q-px-md q-pb-sm"
      >
        {{ article.description }}
      </q-item-label>
      <div class="q-py-md">
        <LiteYouTubeEmbed
          :id="article.platform_id"
          ref="player"
          :title="article.title"
          poster="maxresdefault"
        />
      </div>
    </content-dialog>
  </q-card>
</template>

<script>
import LiteYouTubeEmbed from 'vue-lite-youtube-embed'
import 'vue-lite-youtube-embed/style.css'

export default {
  components: {
    LiteYouTubeEmbed
  },
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dialogOpen: false
    }
  },
  computed: {
    thumbnailImg () {
      return ' https://img.youtube.com/vi/' + this.article.platform_id + '/sddefault.jpg'
    }
  }
}
</script>
